import React from 'react';

import {
  AboutUsPage,
  MapPage,
  RemindersPage,
  RSVPPage,
  SquadPage,
  WelcomePage,
} from './components';
import { ImageModal, SquadModal } from './containers';

export default class App extends React.Component {
  render() {
    return (
      <div className="parent">
        <div className="primary-pane">
          <div className="background">
            <div className="overlay" />
          </div>
          <div className="content-wrapper">
            <div className="content">
              <h1>Jelo & Lorr</h1>
              <h3>
                We are so excited and can&#39;t wait to see you.
                Help us capture our wedding with joy.
              </h3>
            </div>
          </div>
        </div>
        <div className="secondary-pane">
          <WelcomePage />
          <MapPage />
          <RemindersPage />
          <RSVPPage />
          <AboutUsPage />
          <SquadPage />
        </div>
        <ImageModal />
        <SquadModal />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js